import { ApiType } from "@gymflow/common";
import { AppointableCategoryDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export function useAppointableCategoryCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      newAppointableCategory: Omit<AppointableCategoryDTO, "id">,
    ) => {
      return (await api.appointableApi.createCategory(newAppointableCategory))
        .data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: appointableQueryKeys.categoriesAll(),
      });
    },
  });
}
